module.exports = __webpack_public_path__ + "static/tr-section-3@2x-195a79d5a4a0f018fef56d4d1266398d.png";